
import css from "./index.module.css";
import Input from "../../components/Input";
import Button from "../../components/Button";
import logo from "../../assets/morph3dbot_logo_white.svg";

import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
/**
 * Displays Loginform. Toggles inputs for student and teacher.
 */
const Login = () => {
  const [selectedTeacher, setSelectedTeacher] = useState(true);
  const navigate = useNavigate();
  
  const handleSubmitTeacher = async(e) => {
    e.preventDefault();

    const formData = new FormData(e.target);
    const email = formData.get("email");
    const password = formData.get("password");
    
    try {
      // eslint-disable-next-line
      const res = await fetch("https://api.lernplattform.morph3dbot.de/api/login/teacher", {
        method: "POST",
        credentials: "include", // wichtig für Cookies
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: email, password: password }),
      }).then(async (resp) => {
        const response = await resp.json();
        navigate(`/teacher/${response.teacherId}`);
      })
    } catch (err) {
      console.log(err.message);
      navigate("/login");
    }
  }

  const handleSubmitStudent = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const name = formData.get("name");
    const classcode = formData.get("classcode");
    
    try {
      // eslint-disable-next-line
      const res = await fetch("https://api.lernplattform.morph3dbot.de/api/login/student", {
        method: "POST",
        credentials: "include", // wichtig für Cookies
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ classcode: classcode, name: name}),
      }).then (async (resp) => {
        const response = await resp.json();
        if(resp.status === 200){
          navigate(`/student/${response.studentId}/missions`)
        }
      })
    } catch (err) {
      console.log(err.message);
      navigate("/login")
    }
    
  }

  return (
    <div className={css.page}>
      <div className={css.container}>
        <img src={logo} alt="Logo" className={css.logo} />
        <div className={css.tabContainer}>
          <span
            className={selectedTeacher ? css.selectedTab : css.unselectedTab}
            onClick={() => setSelectedTeacher(true)}
          >
            Lehrer:in
          </span>
          <span
            className={selectedTeacher ? css.unselectedTab : css.selectedTab}
            onClick={() => setSelectedTeacher(false)}
          >
            Schüler:in
          </span>
        </div>
        {selectedTeacher ? (
          <form className={css.loginContainer} onSubmit={handleSubmitTeacher}>
            <Input type="text" defaultValue="" label="E-Mail" name="email"/>
            <Input type="password" defaultValue="" label="Passwort" name="password"/>
            
              <Button type="submit">
                Sign In
              </Button>
            
            <Link to="/forgot-password">
              <span className={css.hyperlink}>Forgot Password?</span>
            </Link>
          </form>
        ) : (
          <form className={css.loginContainer} onSubmit={handleSubmitStudent}>
            <Input type="text" defaultValue="" label="Klassencode" name="classcode" />
            <Input type="text" defaultValue="" label="Name" name="name"/>
            <Button type="submit">
              Sign In
            </Button>
          </form>
        )}
      </div>
    </div>
  );
};
export default Login;
